import { createContext, useContext, useState } from 'react';
import { THIRD_PARTY_SHARE_TYPES } from '../../../constants/shareVia';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareViaThirdPartySettingsContext = /*#__PURE__*/createContext(undefined);
export const ShareViaThirdPartySettingsProvider = ({
  children
}) => {
  const [shareOptionType, setShareOptionType] = useState(THIRD_PARTY_SHARE_TYPES.CHANNEL);
  const [shareOptionSelection, setShareOptionSelection] = useState();
  const [message, setMessage] = useState('');
  const contextValue = {
    shareOptionType,
    setShareOptionType,
    shareOptionSelection,
    setShareOptionSelection,
    message,
    setMessage
  };
  return /*#__PURE__*/_jsx(ShareViaThirdPartySettingsContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useShareViaThirdPartySettings = () => {
  const context = useContext(ShareViaThirdPartySettingsContext);
  if (context === undefined) {
    throw new Error('useShareViaThirdPartySettings must be used within a ShareViaThirdPartySettingsProvider');
  }
  return context;
};